import BaseApi from '../base/base'
import Comment, { CommentableType } from '../../models/comment'
import CommentForm from '../../forms/comment'

export default class CommentApi extends BaseApi {
  constructor() {
    super()
    this.path = '/comments'
  }

  async index(commentableId: number, commentableType: CommentableType) {
    this.path = '/comments'
    const response = await this.getRequest({
      commentableId,
      commentableType
    })
    return response.data.map((element) => {
      return new Comment(element)
    })
  }

  async create(params: CommentForm) {
    this.path = '/comments'
    const response = await this.postRequest(params)
    return new Comment(response.data)
  }

  async update(id: number, params: {}) {
    this.path = `/comments/${id}`
    await this.patchRequest(params)
    return true
  }

  async delete(id: number) {
    this.path = `/comments/${id}`
    await this.deleteRequest()
    return true
  }
}
